import { UPDATE_ITEM_SUCCESS } from "../../constants";

const updateItemSuccess =
  ({ id }) =>
  dispatch =>
    dispatch({ type: UPDATE_ITEM_SUCCESS, payload: { id } });

export default updateItemSuccess;
